import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { ModalController } from '@ionic/angular';
import { PlatformService } from 'src/app/platform.service';
import { FormPage } from '../form/form.page';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';

@Component({
  selector: 'app-forms',
  templateUrl: './forms.page.html',
  styleUrls: ['./forms.page.scss'],
})
export class FormsPage  {
  loaded=false
  width = window.innerWidth;
  forms;
  constructor(
    private iab: InAppBrowser,
    private errorhandlerSRV:ErrorHandlerService,
    private modalCtrl:ModalController,
    private dataSRV:DataService,
    public platformSRV:PlatformService
  ) { }

  ionViewWillEnter() {
    this.loaded=false
    this.dataSRV.getData('api/v1/user/forms').subscribe({
      next:res=>{
        if(res['status']=='success'){
          this.forms=res['forms']
          this.loaded=true
        } else {
          this.errorhandlerSRV.displayErrorMessage(res,true)
        }
      },
      error:error=>{
        this.errorhandlerSRV.displayErrorMessage(error,true)
      }
      
      
    })
  }
  async openForm(form){
    if(form.external_form && form.external_form!=''){
      var url = form.external_form
      const browser = this.iab.create(url, '_system')
    } else {
      const desktopModal = await this.modalCtrl.create({
        component: FormPage,
        initialBreakpoint: 1,
        cssClass: 'modal-desktop-long',
        backdropDismiss:false,
        componentProps:{
          id:form.id,
          title:form.title
        }
      });
      const mobileModal = await this.modalCtrl.create({
        component: FormPage,
        breakpoints: [0.5, 0.8,1],
        initialBreakpoint: 1,
        cssClass:"modal-mobile-normal",
        backdropDismiss:false,
        componentProps:{
          id:form.id,
          title:form.title
        }
      })
      const tabletModal = await this.modalCtrl.create({
        component: FormPage,
        breakpoints: [0.5, 0.8,1],
        initialBreakpoint: 1, 
        cssClass:"modal-tablet-normal",
        backdropDismiss:false,
        componentProps:{
          id:form.id,
          title:form.title
        }
      })
      var modal = await this.dataSRV.getModalType(mobileModal, tabletModal, desktopModal)
     modal.present()
    
    }
    
  }

}
